import { Component, Vue } from 'vue-property-decorator';
import { TableContext } from '@/models/table-context.model';

const SESSION_TABLE_STATE = 'com.pawfinders.tablecontext';

@Component({
  computed: {
    page(): string | null | undefined {
      return this.$route.name;
    }
  }
})
export default class TableStateMixin extends Vue {
  public tableContext: Array<TableContext> = [];
  public page: string | null | undefined;
  public currentTableContext: TableContext | null = null;

  public created() {
    this.tableContext = this.getTableContext();

    const table = this.tableContext.find(
      (table) => table.pageName === this.page
    );

    if (table) {
      this.currentTableContext = { ...table };
    }
  }

  private getTableContext(): Array<TableContext> {
    const session = sessionStorage.getItem(SESSION_TABLE_STATE);
    return session ? [...JSON.parse(session)] : [];
  }

  public setTableContext(context: TableContext) {
    const index = this.tableContext.findIndex(
      (table) => table.pageName === this.page
    );

    if (index !== -1) {
      this.tableContext[index] = { ...context };
    } else {
      this.tableContext.push(context);
    }

    sessionStorage.setItem(
      SESSION_TABLE_STATE,
      JSON.stringify(this.tableContext)
    );
  }
}
